import { Text, Link } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'

export default function Footer() {
  return <Text color='gray.500' fontSize='xs'>
    <Link as={RouterLink} to='/eula'>EULA</Link> &middot;  <Link as={RouterLink} to='/privacy'>Privacy Policy</Link> &middot; Copyright &copy; {new Date().getFullYear()} EdenNetwork Italia. All Rights Reserved
  </Text>
}
